import { Dialog } from "primereact/dialog";
import React from "react";
import { T } from "services/lang/LanguageService";
import { Button } from "primereact/button";
import { arrayToCsvfromCharts } from "../product-template-table/utils/utils";
import {
  DataForExportBar,
  DataForExportHistogram,
  DataForExportLineAndScatter,
  IExportCsvDialogProps,
  PieChartDataForExport,
} from "./interfaces";

const ExportCsvDialog = (props: IExportCsvDialogProps) => {
  const { dialog, setDialog, data, chartType } = props;

  const formatDataForCsv = (
    dataForCsv:
      | DataForExportLineAndScatter[]
      | DataForExportBar[]
      | PieChartDataForExport
      | DataForExportHistogram[]
  ) => {
    const csvData: string[][] = [];

    if (chartType === "LINE" || chartType === "SCATTER") {
      csvData.push(["identifier", "name", "type", "mode", "unit", "showlegend", "x", "y"]);

      (dataForCsv as DataForExportLineAndScatter[]).forEach(item => {
        if (item.x && item.y) {
          item.x.forEach((xValue, index) => {
            csvData.push([
              item.identifier,
              item.name,
              item.type,
              item.mode,
              item.unit,
              item.showlegend.toString(),
              xValue,
              item.y![index].toString(),
            ]);
          });
        } else {
          csvData.push([
            item.identifier,
            item.name,
            item.type,
            item.mode,
            item.unit,
            item.showlegend.toString(),
            "",
            "",
          ]);
        }
      });

      return csvData;
    }
    if (chartType === "BAR") {
      csvData.push(["name", "text", "type", "unit", "x", "y"]);

      (dataForCsv as DataForExportBar[]).forEach(item => {
        if (item.x && item.y) {
          item.x.forEach((xValue, index) => {
            csvData.push([
              item.name,
              item.text[index],
              item.type,
              item.unit,
              xValue,
              item.y![index].toString(),
            ]);
          });
        } else {
          csvData.push([item.name, item.text[0], item.type, item.unit, "", ""]);
        }
      });

      return csvData;
    }
    if (chartType === "PIE") {
      csvData.push(["hole", "hoverinfo", "hovertemplate", "labels", "values", "type", "text"]);

      const pieData = dataForCsv as PieChartDataForExport;

      pieData.labels.forEach((label, index) => {
        csvData.push([
          pieData.hole.toString(),
          pieData.hoverinfo,
          pieData.hovertemplate,
          label,
          pieData.values[index].toString(),
          pieData.type,
          pieData.text[index],
        ]);
      });

      return csvData;
    }
    if (chartType === "HISTOGRAM") {
      csvData.push([
        "customdata",
        "histnorm",
        "hovertemplate",
        "marker.color",
        "name",
        "showlegend",
        "type",
        "unit",
        "x",
      ]);

      (dataForCsv as DataForExportHistogram[]).forEach(item => {
        item.x.forEach((xValue, index) => {
          csvData.push([
            item.customdata[index] ? item.customdata[index].toString() : "",
            item.histnorm,
            item.hovertemplate,
            item.marker.color,
            item.name,
            item.showlegend.toString(),
            item.type,
            item.unit,
            xValue.toString(),
          ]);
        });
      });

      return csvData;
    }

    return csvData;
  };

  const exportCSV = () => {
    const formattedData = formatDataForCsv(data);
    const csvContent = arrayToCsvfromCharts(formattedData);
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");

    if (link.download !== undefined) {
      const url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", "chart_data.csv");
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }

    setDialog(false);
  };

  return (
    <Dialog
      header={`${T("action.download")} CSV`}
      visible={dialog}
      onHide={() => setDialog(false)}
      style={{ width: "14rem", textAlign: "center" }}
      resizable={false}
      draggable={false}
    >
      <Button label="CSV" icon="pi pi-download" onClick={exportCSV} />
    </Dialog>
  );
};

export default ExportCsvDialog;
